import { environment } from "./constants";
import getNextScreen from "./getNextScreen";

async function closeTabOverdue(): Promise<string | undefined> {
  const xRooamSession = localStorage.getItem("x-rooam-session");

  const headers = new Headers();
  headers.append("content-type", "application/json");
  environment.originUrl && headers.append("origin", environment.originUrl);
  environment.refererUrl && headers.append("referer", environment.refererUrl);
  xRooamSession && headers.append("x-rooam-session", xRooamSession);

  try {
    const overdueResponse = await fetch(`${environment.baseUrl}/overdue`, {
      method: "POST",
      headers,
      body: JSON.stringify({}),
    });

    if (!overdueResponse.ok) {
      throw new Error(
        `closeTabOverdue > Request failed with status ${overdueResponse.status}`
      );
    }

    const nextScreen = await getNextScreen();

    return nextScreen;
  } catch (error) {
    console.error(error);
  }
}

export default closeTabOverdue;
